import { GridItem, LayoutGrid } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import type { PopTechSpecsFeatureData } from '@/app/[locale]/product/rings/_types';

import PopBottomEyebrow from '../PopBottomEyebrow';
import PopTechSpecsFeatures from './PopTechSpecsFeatures';

export interface PopTechSpecsProps {
  readonly features: PopTechSpecsFeatureData[];
}

const PopTechSpecs = ({ features }: PopTechSpecsProps): JSX.Element => {
  const t = useTranslations();

  return (
    <section>
      <LayoutGrid>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <PopBottomEyebrow Element="h2" className="mb-8 md:mb-12 xl:mb-16">
            {t('pop_tech_specs_title')}
          </PopBottomEyebrow>
        </GridItem>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <PopTechSpecsFeatures features={features} />
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default PopTechSpecs;
